import { Component, Input, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SocialMediaMetadataLego } from '../../shared/dto/social-media-metadata.lego';
import { FormBuilderService } from '../../shared/service/form-builder.service';

@Component({
  selector: 'wl-social-media-lego-edit',
  templateUrl: './social-media-lego-edit.component.html',
  styleUrls: ['./social-media-lego-edit.component.less'],
    standalone: false
})
export class SocialMediaLegoEditComponent implements OnInit {
  @Input() socialMediaData: SocialMediaMetadataLego;
  socialMedias: Array<SelectItem>;

  constructor(private _formBuilderService: FormBuilderService) {}

  ngOnInit(): void {
    this._formBuilderService.getActiveSocialMediaTypes().then(
      (data) =>
        (this.socialMedias = data.Result.map((socialMedia) => {
          return { label: socialMedia.Name, value: socialMedia.SocialMediaTypeID } as SelectItem;
        }))
    );
  }

  socialMediaChanged(socialMediaId: number) {
    this.socialMediaData.Label = this.socialMedias.find((x) => x.value == socialMediaId).label;
  }
}
